import { render, staticRenderFns } from "./TenantEnrollment.vue?vue&type=template&id=36b4919b&scoped=true"
import script from "./TenantEnrollment.vue?vue&type=script&lang=js"
export * from "./TenantEnrollment.vue?vue&type=script&lang=js"
import style0 from "./TenantEnrollment.vue?vue&type=style&index=0&id=36b4919b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b4919b",
  null
  
)

export default component.exports